'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MEDIA_QUERY_MAP = exports.MEDIA_QUERY_MAP = {
  xs: 'screen and (min-width: 23.4375em)',
  sm: 'screen and (min-width: 30em)',
  md: 'screen and (min-width: 48em)',
  lg: 'screen and (min-width: 62em)',
  xl: 'screen and (min-width: 80em)',
  xxl: 'screen and (min-width: 100em)'
};

// Defaults for server-side rendering
var MEDIA_QUERY_DEFAULTS = exports.MEDIA_QUERY_DEFAULTS = {
  xs: true,
  sm: true,
  md: true,
  lg: false,
  xl: false,
  xxl: false
};

var BREAKPOINT_BY_SCREEN_TYPE = exports.BREAKPOINT_BY_SCREEN_TYPE = {
  phone: 'xs',
  tablet: 'md',
  desktop: 'lg'
};

var SCREEN_TYPES = exports.SCREEN_TYPES = {
  phone: 'phone',
  tablet: 'tablet',
  desktop: 'desktop'
};